import * as angular from 'angular';
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import DefectCausesServiceName, {DefectCausesService} from "../../services/defectCauses/defectCause.service";
import ToolChangeServiceName, {ToolChangeService} from "../../services/toolChange/toolChange.service";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import template from './editDefectCause.tpl.html';

let requires = [LoaderServiceName, NotifyServiceName, DefectCausesServiceName, ToolChangeServiceName,
  UIUtilityServiceName];

export default angular.module('aps.controller.editDefectCause', requires)
  .controller('EditDefectCauseCtrl', editDefectCauseCtrl)
  .name;

export interface EditDefectCauseData {
  defectCause: apsViewModels.DefectCauseSelection;
}

export function openEditDefectCause(data: EditDefectCauseData,
                                    $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EditDefectCauseCtrl as editDefectCauseCtrl',
    resolve: {
      data: function() {
        return data
      }
    }
  }).result;
}

function editDefectCauseCtrl(
  $modalInstance: mm.foundation.modalInstance,
  data: EditDefectCauseData,
  loaderService: LoaderService,
  notifyService: NotifyService,
  defectCausesService: DefectCausesService,
  toolChangeService: ToolChangeService,
  uiUtilityService: UIUtilityService
) {
  'use strict';

  let vm = this;

  vm.defectCause = data.defectCause;
  vm.reasons = uiUtilityService.getListOptionsFromEnum(apsEnums.ToolChangeReason, 0);

  toolChangeService.getToolsAndTypes().then((tools) => {
    vm.tools = tools;
  });

  defectCausesService.getCourseOfActions().then(function(courseOfActions) {
    vm.courseOfActions = courseOfActions;
  });

  vm.submitDefectCause = function() {
    if (!vm.defectCause.courseOfActionId) {
      vm.defectCause.toolId = null;
      vm.reason = null;
    }

    let promise = defectCausesService.submitDefectCause(vm.defectCause)
      .then(function () {
        $modalInstance.close(vm.defectCause);
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  vm.cancel = function() {
    $modalInstance.close();
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/defectTypeAdmin/editDefectCause.controller.ts